export const FETCH_HARDWARE_REQUEST = "FETCH_HARDWARE_REQUEST";
export const FETCH_HARDWARE_MUNING_SUCCESS = "FETCH_HARDWARE_MUNING_SUCCESS";
export const FETCH_HARDWARE_NAGIOS_SUCCESS = "FETCH_HARDWARE_NAGIOS_SUCCESS";
export const FETCH_HARDWARE_FAILURE = "FETCH_HARDWARE_FAILURE";
